module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei1.svg";